// extracted by mini-css-extract-plugin
module.exports = {"container":"login-module--container--3RDZI","shadow":"login-module--shadow--2mkGU"};